<template>
  <div class="home-box">
    <v-row>
      <v-col cols="12" lg="4" md="4" offset-md="4" offset-lg="4" sm="12">
        <v-layout row v-if="errors">
          <v-row>
            <Alert @dismissed="onDismissed" :text="errors"></Alert>
          </v-row>
        </v-layout>
        <v-progress-linear
          v-if="loading"
          indeterminate
          color="orange"
        ></v-progress-linear>
        <v-card class="pa-1">
          <v-card-title dark class="mb-2">
            <h5>Please Select a Role</h5>
          </v-card-title>
          <v-card-text>
            <v-form>
              <v-select
                v-model="role"
                :items="roles"
                label="Role*"
                :item-text="'name'"
                :item-value="'name'"
                dense
                outlined
              ></v-select>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="12" md="12" sm="12">
                <v-btn
                  dark
                  color="green"
                  block
                  @click="setRole"
                  :loading="loading"
                  depressed
                  >Next</v-btn
                >
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
        <div style="text-align:center">
          <small>Clubs Performance Evaluation System.</small>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Alert from "@/components/shared/Alert";
import { mapGetters } from "vuex";
import { AuthService } from "../../services/auth-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "SwithRole",
  components: { Alert },
  data() {
    return {
      roles: [],
      errors: null,
      role: localStorage.getItem("role"),
      logo: require("@/assets/logo.png"),
      loading: false,
    };
  },
  mounted() {
    this.getUserRoles();
  },
  computed: {
    ...mapGetters("auth", {
      profile: "profile",
    }),
  },

  methods: {
    setRole() {
      this.$store
        .dispatch("auth/roleSet", {
          role: this.role,
        })
        .then((response) => {
          if (response == this.role) {
            this.$router.push("/");
          }
        });
    },

    getUserRoles() {
      AuthService.getUserRoles()
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.roles = response.data.data;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.roles = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
  },
};
</script>
<style>
.login-page {
  padding-bottom: 100px;
}
</style>
